export default "__VITE_ASSET__BV4FafGA__"